import { gwGet, gwPost } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import createBaseActions, { handleGwData, setPostBody, setGetParams } from '../actionsFactory';
import actionTypes from '../actionsFactory/types';
import makeOrCacheApiReq from '../../utils/apiCache';
import bog from '../../utils/moreBog';

const {
  FETCH_USER_DIVIDENDS,
  FETCH_USER_DIVIDENDS_ERROR,
  SET_USER_DIVIDENDS,
  FETCH_ASSETS,
  FETCH_ASSETS_SUCCESS,
  FETCH_ASSETS_FAILED,
  FETCH_ASSET_INFO_SUCCESS,
  FETCH_ASSET_INFO_ERROR,
  GET_ASSET_MIN_TRADE_INFO,
  GET_SELECT_LIST,
} = actionTypes;

const setUserDividendsData = createBaseActions(SET_USER_DIVIDENDS, 'data');
const setAssets = createBaseActions(FETCH_ASSETS_SUCCESS, 'data');
const setAssetInfo = createBaseActions(FETCH_ASSET_INFO_SUCCESS, 'data');

export const fetchUserDividends = (postData) => async dispatch => {
  dispatch({ type: FETCH_USER_DIVIDENDS });
  try {
    const result = await gwPost(API_PATH.USER_DIVIDENDS_API_PATH, postData);
    dispatch(setUserDividendsData({ data: handleGwData(result) || [], total: result.total }));
  } catch (error) {
    dispatch({ type: FETCH_USER_DIVIDENDS_ERROR, error });
  }
};


export const fetchAssetWithdraw = async req => {
  let result = [];
  try {
    const api = API_PATH.GET_ALL_ASSETS_API_PATH;
    result = await makeOrCacheApiReq(
      api,
      () => gwGet(api, null, req),
      res => res.success && Array.isArray(res.data)
    );
    result = handleGwData(result);
  } catch (error) {
    // nothing
  }
  return result;
};

export const fetchFiatChargeAddressWithoutLogin = async (req, params) => {
  let result = {};
  try {
    const api = API_PATH.GET_CHARGE_ADDRESS_WITHOUT_LOGIN;
    result = await makeOrCacheApiReq(api,
      () => gwPost(api, params),
      res => res.success
    );
  } catch (error) {
    bog.error('error', error);
    // nothing
  }
  return handleGwData(result);
};

export const fetchAllAssets = () => async dispatch => {
  dispatch({ type: FETCH_ASSETS });
  try {
    let result;
    result = await gwGet(API_PATH.GET_ALL_ASSETS_API_PATH);
    result = handleGwData(result);
    dispatch(setAssets(result));
  } catch (error) {
    dispatch({ type: FETCH_ASSETS_FAILED, error });
  }
};

export const fetchAllAssetsLogo = async () => {
  let result = [];
  try {
    result = await gwGet(API_PATH.GET_ALL_ASSETLOGO_API_PATH);
    result = handleGwData(result);
  } catch (error) {
    // nothing
  }
  return result;
};

export const fetchAssetInfo = () => async dispatch => {
  try {
    const data = await gwGet(API_PATH.ASSET_INFO_API);
    dispatch(setAssetInfo(data));
  } catch (error) {
    dispatch({ type: FETCH_ASSET_INFO_ERROR, error });
  }
};

export const getAssetMinTradeInfo = params => async (dispatch) => {
  try {
    const result = await gwGet(`${API_PATH.USER_MIN_TRADE_INFO_PAI_PATH}?${setGetParams(params)}`);

    dispatch({ type: GET_ASSET_MIN_TRADE_INFO, data: result.data });
  } catch (error) {
    bog.error(`Error: withdrawCancel error, message is ${error.message}`);
  }
};

// Fiat
export const getQuote = params => async () => {
  try {
    const result = await gwPost(API_PATH.GET_QUOTE, params);
    return result;
  } catch (error) {
    bog.error(`Error: message is ${error.message}`);
    return {};
  }
};

export const getCryptoList = () => async (dispatch) => {
  try {
    const result = await gwGet(API_PATH.GET_CRYPRO_LIST);
    dispatch({ type: GET_SELECT_LIST, data: result.data });
  } catch (error) {
    bog.error(`Error: get cryptolist error, message is ${error.message}`);
  }
};

export default {};
